export default __webpack_public_path__ + "static/media/trust-wallet.4121118e.png";